export const SCOPE = '.request';

export const INIT = `${SCOPE}:REQUEST/INIT`;

export const SET_PAYLOAD = `${SCOPE}:REQUEST/SET_PAYLOAD`;
export const SET_RESPONSE = `${SCOPE}:REQUEST/SET_RESPONSE`;

export const FETCHING = `${SCOPE}:REQUEST/FETCHING`;
export const FETCHING_SUCCESS = `${SCOPE}:REQUEST/FETCHING_SUCCESS`;
export const FETCHING_FAIL = `${SCOPE}:REQUEST/FETCHING_FAIL`;
export const ABORT_FETCHING = `${SCOPE}:REQUEST/ABORT_FETCHING`;
export const END_FETCHING = `${SCOPE}:REQUEST/END_FETCHING`;
